import styled from "styled-components";

export const Container = styled.div`
  height: 568px;
  width: 337px;
  border: 2px solid #fafafa;
  display: flex;
  margin: 0 8px;
`;

export const SideBar = styled.div`
  min-width: 64px;
  display: flex;
  align-items: flex-end;
  position: relative;

  span {
    position: absolute;
    /* border-bottom: 2px solid #ddd; */
    transform: rotateZ(-90deg);
    transform-origin: 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 568px;
    height: 64px;
    bottom: -64px;

    overflow: hidden;

    font-size: 1.64rem;
    letter-spacing: 0.2rem;
    * {
      white-space: nowrap;
    }

    b {
      margin-left: 16px;
      font-family: "Space Mono", monospace;
    }
  }
`;

export const ContentContainer = styled.div`
  flex-grow: 1;
  padding: 32px 16px 8px;
  overflow-y: auto;

  img {
    width: 100%;
    height: 120px;
    object-fit: cover;
    filter: saturate(0);
  }
`;
